import React, { useRef, useCallback, useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  ConfigProvider,
  Image,
  Card,
  Radio,
  Modal,
  Form,
  Input,
  Carousel,
  Divider,
} from "antd";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import {
  LoadingOutlined,
  CloseOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setDataNewProgram } from "../redux/features/notification/notificationSlice";
import { setInvalidToken } from "../redux/features/main/invalidTokenSlice";

import { updateNotificationFlag } from "../api/repositories";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import defaultImage from "../assets/images/png/general/img_thumb_default.png";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";

import {
  iconGeneralBackground,
  colorTextDesc,
  ColorPrimary,
  ColorSecondary,
  colorTextTitleMobile,
} from "../config/constant/color/index";

const ModalNotifNewProgram = () => {
  const dataNewProgram = useSelector(
    (state) => state.notification.dataNewProgram,
  );
  const lastLogin = useSelector((state) => state.onboarding.lastLogin);
  const canFetchNotifProgram = useSelector(
    (state) => state.onboarding.canFetchNotifProgram,
  );
  const dispatch = useDispatch();
  const screens = useBreakpoint();
  const isScallingVersion =
  window.innerWidth < 992 && (window.innerHeight >= window.innerWidth || window.innerWidth > window.innerHeight);
  const isMobileVersion = screens.xs;

  const location = useLocation();

  const sliderRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  

  const programData = [
    {
      image: defaultImage,
      title:
        "Journey Begins, Forward Your Experience Journey Begins, Forward Your Experience Journey Begins, Forward Your Experience",
      desc: "Program pembelajaran ini ditujukan kepada karyawan baru Intikom. Setelah menyelesaikan program ini, karyawan mampu beradaptasi dan implementasi nilai serta budaya perusahaan secara efektif dalam aktivitas sehari-hari. Program pembelajaran ini ditujukan kepada karyawan baru Intikom. Setelah menyelesaikan program ini, karyawan mampu beradaptasi dan implementasi nilai serta budaya perusahaan secara efektif dalam aktivitas sehari-hari. Program pembelajaran ini ditujukan kepada karyawan baru Intikom. Setelah menyelesaikan program ini, karyawan mampu beradaptasi dan implementasi nilai serta budaya perusahaan secara efektif dalam aktivitas sehari-hari. Program pembelajaran ini ditujukan kepada karyawan baru Intikom. Setelah menyelesaikan program ini, karyawan mampu beradaptasi dan implementasi nilai serta budaya perusahaan secara efektif dalam aktivitas sehari-hari.",
    },
    {
      image: defaultImage,
      title: "Journey Begins, Forward Your Experience",
      desc: "Program pembelajaran ini ditujukan kepada karyawan baru Intikom. Setelah menyelesaikan program ini, karyawan mampu beradaptasi dan implementasi nilai serta budaya perusahaan secara efektif dalam aktivitas sehari-hari.",
    },
    {
      image: defaultImage,
      title: "Journey Begins, Forward Your Experience",
      desc: "Program pembelajaran ini ditujukan kepada karyawan baru Intikom. Setelah menyelesaikan program ini, karyawan mampu beradaptasi dan implementasi nilai serta budaya perusahaan secara efektif dalam aktivitas sehari-hari.",
    },
  ];

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  const onSwiperMove = (e) => {
    var btnPrev = document.querySelector("#id-btn-prev-new-program-notif");
    var btnNext = document.querySelector("#id-btn-next-newprogram-notif");
    
    console.log(e.activeIndex);

    if (btnPrev !== null && btnNext !== null) {
      if (e.activeIndex === 0) {
        btnPrev.classList.add("hidden");
      } else {
        btnPrev.classList.remove("hidden");
      }

      if (e.activeIndex === dataNewProgram.length - 1) {
        btnNext.classList.add("hidden");
      } else {
        btnNext.classList.remove("hidden");
      }
    }
  };

  const handleCloseUpdate = async () => {
    const newArrIdNotif = [].concat(
      ...dataNewProgram.map((item, index) => {
        return item.id_notif;
      }),
    );
    // console.log(newArrIdNotif)

    const payload = {
      id: [...newArrIdNotif],
      status: 1, // always 1
    };

    try {
      const { status } = await updateNotificationFlag({ data: payload });
      console.log(status);
      dispatch(setInvalidToken(status));
      if (status === 200) {
      }
    } catch (err) {
      alert("Error update notif " + err);
    } finally {
      dispatch(setDataNewProgram([]));
    }
  };

  useEffect(() => {
    const url = location.pathname;
    // console.log(url.indexOf('/home')+" == "+dataNewProgram.length)
    if (lastLogin !== null) {
      if (
        lastLogin.toLowerCase() !== "web" &&
        lastLogin.toLowerCase() !== "mobile_and_web" &&
        lastLogin !== null
      ) {
      } else {
        // console.log("CHECK New P 1")
        if (url.indexOf("/home") > -1) {
          if (dataNewProgram.length > 0) {
            setIsOpen(true);
          } else {
            setIsOpen(false);
          }
        }
      }
    } else {
      // console.log("CHECK New P 2")
      if (url.indexOf("/home") > -1) {
        if (dataNewProgram.length > 0) {
          setIsOpen(true);
        } else {
          setIsOpen(false);
        }
      }
    }
  }, [location, dataNewProgram, lastLogin]);

  useEffect(() => {
    const url = location.pathname;

    if (canFetchNotifProgram === true) {
      if (url.indexOf("/home") > -1) {
        if (dataNewProgram.length > 0) {
          setIsOpen(true);
        } else {
          setIsOpen(false);
        }
      }
    }
  }, [canFetchNotifProgram]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Carousel: {
            dotActiveWidth: 12,
            dotHeight: 12,
            dotWidth: 12,
          },
        },
        token: {
          fontFamily: "Roboto",
          borderRadiusLG: isMobileVersion ? 12 : 16,
        },
      }}
    >
      <Modal
        className={
          isMobileVersion
            ? "modal-notif-new-program mobile"
            : "modal-notif-new-program"
        }
        open={isOpen}
        maskClosable={false}
        closeIcon={
          <div
            style={{
              padding: "9px 10px",
              display: "flex",
              background: iconGeneralBackground,
              borderRadius: "50%",
              border: "none",
            }}
            id="btn-modal-close-notif-new-program"
          >
            <CloseOutlined style={{ color: colorTextDesc, fontSize: "14px" }} />
          </div>
        }
        width={
          isMobileVersion ? (isScallingVersion ? `${585 * 0.9}px` : "90%") : 480
        }
        onCancel={() => {
          setIsOpen(!isOpen);
          handleCloseUpdate();
        }}
        transitionName="ant-fade"
        keyboard
        centered
        footer={false}
        title={
          <div
            style={{
              padding: isMobileVersion ? "18px" : "31px 32px 12px 32px",
              fontSize: isMobileVersion ? 16 : 22,
              fontWeight: isMobileVersion ? 500 : "bold",
              lineHeight: isMobileVersion ? "18px" : "normal",
            }}
          >
            NEW PROGRAM FOR YOU!
          </div>
        }
        style={{ borderRadius: isMobileVersion ? 12 : 16 }}
      >
        <div
          style={{
            padding: isMobileVersion
              ? "0 18px"
              : `0 32px ${dataNewProgram.length > 1 ? "24px" : "31px"} 32px`,
            position: "relative",
          }}
        >
          {dataNewProgram.length > 0 ? (
            dataNewProgram.length > 1 ? (
              <Swiper
                ref={sliderRef}
                slidesPerView={1}
                spaceBetween={20}
                pagination={{
                  clickable: true,
                }}
                modules={[Navigation, Pagination]}
                onSlideChange={(e) => onSwiperMove(e)}
                freeMode={false}
              >
                {dataNewProgram.map((item, index) => (
                  <SwiperSlide key={item.id_notif} data-id={item.id_notif}>
                    <div
                      className="image-journey-notif"
                      style={{ marginBottom: isMobileVersion ? 18 : 20 }}
                    >
                      <Image
                        style={{ borderRadius: 8, objectFit: "cover" }}
                        width={isMobileVersion ? "100%" : 416}
                        height={isMobileVersion ? 176 : 230}
                        preview={false}
                        src={item.thumbnail}
                        fallback={defaultImage}
                      />
                    </div>
                    <div
                      className="title-journey-notif"
                      style={{
                        fontSize: 16,
                        fontWeight: 500,
                        marginBottom: isMobileVersion ? 12 : 8,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        lineHeight: isMobileVersion ? "19px" : "normal",
                        color: isMobileVersion
                          ? colorTextTitleMobile
                          : "inherit",
                      }}
                    >
                      {item.name}
                    </div>
                    <div
                      className="desc-journey-notif break-dots-fifth-line"
                      style={{
                        fontSize: 14,
                        color: colorTextDesc,
                        lineHeight: isMobileVersion ? "20px" : 1.3,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item.description}
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <div data-id={dataNewProgram[0].id_notif}>
                <div
                  className="image-journey-notif"
                  style={{ marginBottom: isMobileVersion ? 18 : 20 }}
                >
                  <Image
                    style={{ borderRadius: 8, objectFit: "cover" }}
                    width={isMobileVersion ? "100%" : "100%"}
                    height={isMobileVersion ? 176 : 234}
                    preview={false}
                    src={dataNewProgram[0].thumbnail}
                    fallback={defaultImage}
                  />
                </div>
                <div
                  className="title-journey-notif"
                  style={{
                    fontSize: 16,
                    fontWeight: 500,
                    marginBottom: isMobileVersion ? 12 : 8,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    lineHeight: isMobileVersion ? "19px" : "normal",
                    color: isMobileVersion ? colorTextTitleMobile : "inherit",
                  }}
                >
                  {dataNewProgram[0].name}
                </div>
                <div
                  className="desc-journey-notif break-dots-fifth-line"
                  style={{
                    fontSize: 14,
                    color: colorTextDesc,
                    lineHeight: isMobileVersion ? "20px" : 1.3,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {dataNewProgram[0].description}
                </div>
              </div>
            )
          ) : null}
          <div
            style={{
              display: dataNewProgram.length > 1 ? "flex" : "none",
              position: "absolute",
              top: 100,
              width: "100%",
              left: 0,
              justifyContent: "space-between",
            }}
          >
            {!isMobileVersion && (
              <div
                onClick={handlePrev}
                style={{
                  color: ColorPrimary,
                  background: ColorSecondary,
                  borderRadius: "8px",
                  border: "1px solid " + ColorPrimary,
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  justifyContent: "center",
                  zIndex: 5,
                  cursor: "pointer",
                  marginLeft: 17,
                }}
                id="id-btn-prev-new-program-notif"
                className="swiper-button btn-prev-new-program-notif hidden"
                name="btn-swiper-prev-new-program-notif"
              >
                <LeftOutlined />
              </div>
            )}
            {!isMobileVersion && (
              <div
                onClick={handleNext}
                style={{
                  color: ColorPrimary,
                  background: ColorSecondary,
                  borderRadius: "8px",
                  border: "1px solid " + ColorPrimary,
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  justifyContent: "center",
                  zIndex: 5,
                  cursor: "pointer",
                  marginRight: 17,
                }}
                id="id-btn-next-newprogram-notif"
                className="swiper-button btn-next-newprogram-notif"
                name="btn-swiper-next-new-program-notif"
              >
                <RightOutlined />
              </div>
            )}
          </div>
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default ModalNotifNewProgram;
